module.exports = __webpack_public_path__ + "static/img/produto_g.82a7be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_tubaina/produto_g.png
// module id = TYHh
// module chunks = 0